import React, { useEffect, useState } from "react";
//import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/FooterBar.css";
import MenuFooter from "./MenuFooter";
import { useAuth } from "../contexts/AuthContext";
import GenericService from "../services/Generic.service";
import packageJson from "../../package.json"

export default function FooterBar(props) {
  const { domainDetails } = useAuth();
  const [configuracoes, setConfiguracoes] = useState(undefined);
  const [contato, setContato] = useState(undefined);
  const [endereco, setEndereco] = useState(undefined);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (domainDetails != null && configuracoes === undefined && !loading) {
      setLoading(true);
      try {
        (async () => {
          await GenericService.getOne("entidades", domainDetails.domainId).then(async (retData) => {
            if (retData) {
              setConfiguracoes(retData.configuracoes);
              setContato(retData.dadosContato);
              setEndereco(retData.dadosEndereco);
            } else {
              //console.log("Nada encontrado!");
            }
          });
        })();
      } catch (err) {
        //console.log(err);
      }
    }
  }, [domainDetails]);

  const canRender = () => {
    return configuracoes && contato && endereco;
  };
  // //console.log("domainDetails.portalId: ", domainDetails.portalId);
  return (
    <>
      {canRender() ? (
        <>
          {domainDetails && domainDetails.portalId === "3" && (
            <div className="d-flex justify-content-center w-100 ps-3 pe-3">
              <div className="alert alert-info d-flex align-items-center" role="alert">
                <span className="material-icons-outlined me-2">accessibility</span>
                <div style={{ fontSize: "0.85rem" }}>Este portal é acessivel também em libras e por locução. Para ativar estes recursos de acessibilidade utilize as icones azuis a direita.</div>
              </div>
            </div>
          )}
          <div className="bigFooter">
            <div className="sectionsManager">
              <div className="sections-1-and-2-Manager">
                <div className="footer-section1">
                  <div className="GrupoRedeSocial-small">
                    {contato.perfilFacebook.length > 0 && (
                      <a href={contato.perfilFacebook} target="_blank" rel="noreferrer">
                        <img className="iconeRedeSocial-small" src="/assets/images/facebook.png" alt="Facebook" />
                      </a>
                    )}
                    {contato.perfilInstagram.length > 0 && (
                      <a href={contato.perfilInstagram} target="_blank" rel="noreferrer">
                        <img className="iconeRedeSocial-small" src="/assets/images/instagram.png" alt="Instagram" />
                      </a>
                    )}
                    {contato.perfilTwitter.length > 0 && (
                      <a href={contato.perfilTwitter} target="_blank" rel="noreferrer">
                        <img className="iconeRedeSocial-small" src="/assets/images/twitter.png" alt="Twitter" />
                      </a>
                    )}
                    {contato.perfilLinkedIn && contato.perfilLinkedIn.length > 0 && (
                      <a href={contato.perfilLinkedIn} target="_blank" rel="noreferrer">
                        <img className="iconeRedeSocial-small" src="/assets/images/linkedin_black.png" alt="LinkedIn" />
                      </a>
                    )}
                    {contato.perfilYouTube.length > 0 && (
                      <a href={contato.perfilYouTube} target="_blank" rel="noreferrer">
                        <img className="iconeRedeSocial-small" src="/assets/images/youtube.png" alt="Youtube" />
                      </a>
                    )}
                  </div>
                  <div className="pContactUs">
                    Horario de funcionamento.
                    <br />
                    {configuracoes.horarioFuncionamento}
                    <br />
                    <br />
                    {endereco.logradouro}
                    {","}
                    {endereco.logradouroNumero}
                    {" - "}
                    {endereco.logradouroComplemento}
                    <br />
                    {endereco.logradouroBairro}
                    {" - "}
                    {endereco.logradouroMunicipio}
                    {"/"}
                    {endereco.logradouroUF}
                    <br />
                    {"CEP: "}
                    {endereco.cep}
                  </div>
                  <div className="pContactUs-info">
                    <div className="float-tel">Tel:<br /><br />E-mail:</div>
                    <div className="float-number">
                      {contato.telefone}
                      <br />
                      {contato.telefoneComercial}
                      <br />
                      <a className="linkMenuHeaderFooter" href={`mailto:${contato.email}`} target="_blank" rel="noreferrer">{contato.email}</a>
                    </div>
                  </div>
                  {/* <div className="pContactUs-links-section">
                    <a href="#" className="btn btn-link linkFooter text-nowrap">
                      Informações de contato
                    </a>
                  </div> */}
                </div>
              </div>
              <div>{domainDetails && <MenuFooter portalid={domainDetails.portalId} />}</div>
            </div>
            <div className="pCopyrights-info d-flex flex-wrap-reverse pt-2">
              <div className="d-flex">
                <div>
                  <a href="#" className="btn btn-link linkFooter text-nowrap text-decoration-none">
                    Informações de contato
                  </a>
                </div>
                &nbsp;&nbsp;|&nbsp;&nbsp;
                <div>
                  <a href="/privacy-politics" className="btn btn-link linkFooter text-nowrap text-decoration-none">
                    Política de privacidade
                  </a>
                </div>
                &nbsp;&nbsp;|&nbsp;&nbsp;
                <div>
                  Versão: {packageJson.version}
                </div>
              </div>
              <div>{`Copyright © 2022-${new Date().getFullYear()}. Todos os direitos reservados`}</div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
}
